import { render, staticRenderFns } from "./HomeworkPlan.vue?vue&type=template&id=cd1c3a08"
import script from "./HomeworkPlan.vue?vue&type=script&lang=js"
export * from "./HomeworkPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd1c3a08')) {
      api.createRecord('cd1c3a08', component.options)
    } else {
      api.reload('cd1c3a08', component.options)
    }
    module.hot.accept("./HomeworkPlan.vue?vue&type=template&id=cd1c3a08", function () {
      api.rerender('cd1c3a08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/homework/HomeworkPlan.vue"
export default component.exports